import { render } from "./TrainConfigModelsAndPerformanceCell.vue?vue&type=template&id=18184bbe"
import script from "./TrainConfigModelsAndPerformanceCell.vue?vue&type=script&lang=js"
export * from "./TrainConfigModelsAndPerformanceCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__